import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "star" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M10.7125 1.29907L7.78319 7.2385L1.22918 8.19401C0.053853 8.36448 -0.417174 9.81345 0.435161 10.6434L5.17683 15.2639L4.05534 21.791C3.85347 22.9708 5.09609 23.8545 6.13683 23.3028L12 20.2209L17.8632 23.3028C18.9039 23.8501 20.1465 22.9708 19.9447 21.791L18.8232 15.2639L23.5648 10.6434C24.4172 9.81345 23.9461 8.36448 22.7708 8.19401L16.2168 7.2385L13.2875 1.29907C12.7626 0.240382 11.2419 0.226924 10.7125 1.29907Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }